import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/** Login "what's new" modal: a thin shell around the shared release-notes list. */
@Component({
  selector: 'app-release-notes-dialog',
  templateUrl: './release-notes-dialog.component.html',
  styleUrls: ['./release-notes-dialog.component.scss'],
})
export class ReleaseNotesDialogComponent {
  constructor(private dialogRef: MatDialogRef<ReleaseNotesDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
